/* src/app/features/tarefas/recuperacao-de-credito/tarefas-recuperacao-de-credito.component.scss */
h5 {
  margin-bottom: 40px;
}
.submit.col-auto {
  margin-top: 20px;
}
.d-flex.title {
  padding-right: 724px;
  font-weight: bold;
}
.d-flex.title2 {
  padding-right: 655px;
  font-weight: bold;
}
.d-flex.title3 {
  padding-right: 699px;
  font-weight: bold;
}
.d-flex.title4 {
  padding-right: 626px;
  font-weight: bold;
}
.d-flex.title5 {
  padding-right: 692px;
  font-weight: bold;
}
.d-flex.title6 {
  padding-right: 607px;
  font-weight: bold;
}
/*# sourceMappingURL=tarefas-recuperacao-de-credito.component.css.map */
